import { render, staticRenderFns } from "./customer-case.vue?vue&type=template&id=47a2038c&"
import script from "./customer-case.vue?vue&type=script&lang=js&"
export * from "./customer-case.vue?vue&type=script&lang=js&"
import style0 from "./customer-case.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VExpandTransition,VHover,VOverlay})
